/**
 * @generated SignedSource<<9bcc732653c2d0578aa960643299cb8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespSearchResultContainer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer" | "useSbSharedItemTracking_viewer">;
  readonly " $fragmentType": "SbRespSearchResultContainer_viewer";
};
export type SbRespSearchResultContainer_viewer$key = {
  readonly " $data"?: SbRespSearchResultContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespSearchResultContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespSearchResultContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSbSharedItemTracking_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0729d1dd1831a936139de2eb6340d59c";

export default node;
